import React from 'react';

import { useNavigate } from 'react-router';

import sadSunImg from '../assets/images/sad-sun.png';
import BnplFormContainer from '../components/Bnpl/BnplFormContainer';
import BnplLoanError from '../components/Bnpl/BnplLoanError';
import Layout from '../components/common/Layout';
import TenantConfig from '../config';
import { sanitizeHtml } from '../helpers/format';

const Denied = () => {
  const navigate = useNavigate();

  if (TenantConfig.getTenant() === 'lightrx') {
    return (
      <BnplFormContainer hideBack={true}>
        <BnplLoanError className="bnpl-form" />
      </BnplFormContainer>
    );
  }

  return (
    <Layout>
      <div className="denied-page">
        <div className="page-inner">
          <div>
            <h2 dangerouslySetInnerHTML={{ __html: sanitizeHtml(TenantConfig?.denied?.title) }} />
            <p>{TenantConfig?.denied.content}</p>
            <button className="primary-btn" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </button>
          </div>
          {TenantConfig?.denied.renderSunImg && <img src={sadSunImg} alt="" />}
        </div>
      </div>
    </Layout>
  );
};

export default Denied;
